


















































































































import { Vue, Component } from 'vue-property-decorator';
import DialogWrapper from '@/components/dialogWrapper.vue';
import { Account } from '@/modules/me';
import { UserTypes } from '@/enums/userTypes';
import { FunctionTypes } from '@/enums/functionTypes';
import store from '@/store';
import { GradeYears, getGradeYearName, getGradeYearItems } from '@/enums/gradeYears';
import Axios from 'axios';
import { GradeAdvanceCondition } from '@/models/gradeAdvanceCondition';
import { GradeAdvanceSettingResponse } from '@/models/gradeAdvanceSettingResponse';
import { GradeAdvanceSettingRequest } from '@/models/gradeAdvanceSettingRequest';
import { ElForm } from 'node_modules/element-ui/types/form';

Component.registerHooks([
  'beforeRouteEnter',
]);

@Component
export default class GradeAdvanceSetting extends Vue {
  private GradeYears = GradeYears;
  private getGradeYearName = getGradeYearName;
  private getGradeYearItems = getGradeYearItems;

  private loading = false;

  private monthList = [...Array(12)].map((_, i) => i + 1);
  private dayList = [...Array(31)].map((_, i) => i + 1);

  private beforeGradeAdvanceSetting = {
    isAutoAdvance: false,
    autoAdvanceMonth: 4,
    autoAdvanceDay: 1,
    gradeAdvanceConditions: new Array<GradeAdvanceCondition>(),
  };

  private gradeAdvanceSetting = {
    isAutoAdvance: false,
    autoAdvanceMonth: 4,
    autoAdvanceDay: 1,
    gradeAdvanceConditions: new Array<GradeAdvanceCondition>(),
  };

  private formRule = {
    autoAdvanceMonthAndDay: [
      { validator: this.validateAdvanceMonthAndDay }
    ],
    autoAdvanceMonth: [
      { validator: this.validateAdvanceMonth }
    ],
    autoAdvanceDay: [
      { validator: this.validateAdvanceDay }
    ],
  };

  private advanceGradeConfirmRule = {
    checkYes: [
      { required: true, message: `削除する場合は「はい」を入力してください` },
      {
        pattern: '^はい$',
        message: `削除する場合は「はい」を入力してください`,
        trigger: 'blur'
        },
    ],
  };

  private validateAdvanceMonthAndDay(rule: any, value: any, callback: any) {
    if (this.gradeAdvanceSetting.autoAdvanceMonth && this.gradeAdvanceSetting.autoAdvanceDay) {
      switch (this.gradeAdvanceSetting.autoAdvanceMonth) {
        case 2:
          if (this.gradeAdvanceSetting.autoAdvanceDay > 28) {
            callback(new Error('28日までを指定してください'));
          }
          break;
        case 4:
        case 6:
        case 9:
        case 11:
          if (this.gradeAdvanceSetting.autoAdvanceDay > 30) {
            callback(new Error('30日までを指定してください'));
          }
          break;
      }
    }
    callback();
  }

  private validateAdvanceMonth(rule: any, value: any, callback: any) {
    this.form.validateField('autoAdvanceMonthAndDay', callback);
  }

  private validateAdvanceDay(rule: any, value: any, callback: any) {
    this.form.validateField('autoAdvanceMonthAndDay', callback);
  }

  private tableRowClassName({ row }: { row: GradeAdvanceCondition }) {
    if (row.beforeGradeYear !== row.afterGradeYear) {
      return 'advance-target-row';
    }
    return '';
  }

  get isMini(): boolean {
    return (this as any).$mq === 'mini';
  }

  get user(): Account {
    return this.$store.state.me.user;
  }

  get availableFunction(): number {
    if (!this.user) {
      return 0;
    }
    return this.user.availableFunctionbit;
  }

  get form(): ElForm {
    return this.$refs.form as ElForm;
  }

  private beforeRouteEnter(to: any, from: any, next: any) {
    switch (store.getters['auth/userType']) {
      case UserTypes.Admin:
      case UserTypes.Owner:
      case UserTypes.AdminTutor:
        next();
        break;
      default:
        next({ name: 'Error' });
        break;
    }
  }

  private async mounted() {
    await this.loadData();
  }

  private deactivated(): void {
    this.$destroy();
  }

  private async loadData() {
    this.loading = true;

    try {
      const response = await Axios.get<GradeAdvanceSettingResponse>('/api/School/GetGradeAdvanceSetting');
      const data = response.data;
      this.beforeGradeAdvanceSetting = {
        isAutoAdvance: data.isAutoAdvance,
        autoAdvanceMonth: data.autoAdvanceMonth,
        autoAdvanceDay: data.autoAdvanceDay,
        gradeAdvanceConditions: data.gradeAdvanceConditions,
      };
    } catch (error) {
      this.beforeGradeAdvanceSetting = {
        isAutoAdvance: false,
        autoAdvanceMonth: 4,
        autoAdvanceDay: 1,
        gradeAdvanceConditions: [],
      };
      this.$notify.error('学年繰り上げ設定の取得に失敗しました');
    }

    this.gradeAdvanceSetting = JSON.parse(JSON.stringify(this.beforeGradeAdvanceSetting));

    this.loading = false;
  }

  private async onRegist() {
    const isValid = await new Promise((resolve) => {
      this.form.validate((valid) => {
        resolve(valid);
      });
    });

    if (!isValid) {
      this.$message.error('設定に誤りがあります');
      return;
    }

    try {
      await this.$confirm('学年繰り上げ設定を変更します。よろしいですか？', '学年繰り上げ設定変更', {
        confirmButtonText: '変更',
        cancelButtonText: 'キャンセル',
        type: 'info'
      });
    } catch (error) {
      return;
    }

    this.loading = true;

    try {
      const request: GradeAdvanceSettingRequest = {
        isAutoAdvance: this.gradeAdvanceSetting.isAutoAdvance,
        autoAdvanceMonth: this.gradeAdvanceSetting.autoAdvanceMonth,
        autoAdvanceDay: this.gradeAdvanceSetting.autoAdvanceDay,
        gradeAdvanceConditions: this.gradeAdvanceSetting.gradeAdvanceConditions.map((item) => ({
          beforeGradeYear: item.beforeGradeYear,
          afterGradeYear: item.afterGradeYear,
        }))
      };
      await Axios.post('/api/School/EditGradeAdvanceSetting', request);

      this.beforeGradeAdvanceSetting = JSON.parse(JSON.stringify(this.gradeAdvanceSetting));

      this.$notify({
        title: '変更完了',
        message: '学年繰り上げ設定を変更しました。',
        position: 'bottom-right',
      });
    } catch (error) {
      this.$notify.error({
        title: 'エラー',
        message: error.message,
        position: 'bottom-right',
      });
    }

    this.loading = false;
  }

  private onCancel() {
    this.$router.push({ name: 'SchoolEdit' });
  }

  private async onExecuteGradeAdvance() {
    if (JSON.stringify(this.beforeGradeAdvanceSetting) !== JSON.stringify(this.gradeAdvanceSetting)) {
      this.$alert('設定が変更されています。<br>実行する場合は先に変更を保存してください。', '', {
        type: 'error',
        dangerouslyUseHTMLString: true,
        closeOnClickModal: true,
      });
      return;
    }

    try {
      await (this.$refs.advanceGradeConfirm as DialogWrapper).open({});
    } catch (error) {
      return;
    }

    this.loading = true;

    try {
      await Axios.post('/api/School/AdvanceGradeYears');

      this.$notify({
        title: '繰り上げ完了',
        message: '学年繰り上げが完了しました。',
        position: 'bottom-right',
      });

      this.loadData();
    } catch (error) {
      this.$notify.error({
        title: 'エラー',
        message: (error.response && error.response.data) || '学年繰り上げが失敗しました',
        position: 'bottom-right',
      });
    }

    this.loading = false;
  }

  private submitAdvanceGradeForm() {
    (this.$refs.advanceGradeConfirmForm as ElForm).validate((valid) => {
      if (valid) {
        (this.$refs.advanceGradeConfirm as DialogWrapper).submit();
      } else {
        return false;
      }
    });
  }
}
